export default __webpack_public_path__ + "static/media/mons11.d0640eee.jpg";